import { FC, HTMLAttributes, useEffect, useState } from "react";
import clx from "classnames";
import API from "./API";
import { CustomerListItemType } from "./Types";
import { UserInfo } from "src/Components";
import { SelectBox } from "src/UI";
import { RenderOptionType } from "src/UI/SelectBox";
import st from "./CustomersSelect.module.scss";

interface ICustomerSelectProps extends HTMLAttributes<HTMLDivElement> {

	placeholder?: string;
	showClearBtn?: boolean;
	minSearchLength?: number;
	disabled?: boolean;
	invalidate?: boolean;

	value?: string;
	setValue: ( value?: CustomerListItemType ) => void;
};

export const CustomerSelect: FC<ICustomerSelectProps> = ( props ) => {

	const { value, setValue, showClearBtn = false, minSearchLength = 3, placeholder = "", invalidate = false,
		disabled = false, className, ...otherProps
	} = props;

	const [ isOpened, setIsOpen ] = useState<boolean>(false);
	const [ isWait, setIsWait ] = useState<boolean>(false);
	const [ data, setData ] = useState<CustomerListItemType[]>([]);
	const [ selected, setSelected ] = useState<CustomerListItemType>();

	// Тут, ежели указано выбранное значение, то загружаем данные
	useEffect( () => {
		if ( !!value && !selected ) {
			loadSelected(value);
		}
	// eslint-disable-next-line
	}, [ value ] );

	/** Загрузка списка заявителей */
	const loadList = ( search?: string ) => {
		// if ( !isOpened ) return;
		setIsWait(true);
		API.getCustomers( search )
			.then( res => {
				if ( res.hasError || !res.result ) {
					return;
				}
				setData( res.result );
			})
			.catch( (e: any) => {
				console.warn(e);
			})
			.finally( () => setIsWait(false) );
	};

	/** Получение данных выбранного заявителя  */
	const loadSelected = ( customerId: string ) => {
		setIsWait(true);
		API.getCustomerById( customerId )
			.then( res => {
				if ( res.hasError || !res.result ) {
					return;
				}
				setSelected( res.result );
			})
			.catch( (e: any) => {
				console.warn(e);
			})
			.finally( () => setIsWait(false) );
	}

	/** Вызывается при выборе заявителя */
	const onChangeSelectedHandler = ( val: any[] ) => onSelected( val[0] );

	/** Сохраняет значения выбранного заявителя */
	const onSelected = ( participant: CustomerListItemType ) => {
		setValue( participant );
		setSelected( participant );
	};

	/** Полный сброс данных ( значение, список и выбранный заявителя ) */
	const onClearHandler = () => {
		setValue(undefined);
		setData([]);
		setSelected(undefined);
	};

	/** Получение и форматирование ДУЛ */
	const getDulNumber = ( source: string ): string => {
		if ( !source ) return "";
		else if ( source.length > 5 && source.indexOf(' ') ) 
			return `${source.substring(0, 4)} ${source.substring( 4 )}`;
		return source;
	};

	/** Отрисовка элемента списка */
	const renderOption: RenderOptionType = ( item: CustomerListItemType, isSelected, searchText, index ) => (
		<UserInfo 
			key={ "item_" + index}
			avatar={item.metaData.avatar}
			gender={item.metaData.gender}
			userName={item.metaData.name} 
			userOrg={ getDulNumber( item.metaData.docNumber ) }
			notHovered
		/>
	);

	/** Отрисовка выпадающего списка */
	const renderSelect = () => (
		<SelectBox
			minSearchLength={3}
			allowClear={showClearBtn}
			className={className}
			isInvalidate={invalidate}
			selectedValues={[value]}
			options={data}
			placeholder={placeholder}
			isWait={isWait}
			readonly={disabled}
			defaultOpen={isOpened}
			valueField='id'
			titleField='text'
			onSearch={loadList}
			onChangeSelected={onChangeSelectedHandler}
			onRenderOption={renderOption}
			onChangeOpen={ open => !open && setIsOpen(false) }
			{...otherProps}
		/>
	);

	if ( !!value && !!selected )
		return (
			<UserInfo 
				gender={selected?.metaData.gender}
				avatar={selected?.metaData.avatar}
				userName={selected.metaData.name} 
				userOrg={ getDulNumber( selected.metaData.docNumber ) }
				className={ clx(className, st.viewItem, { [st.error]: invalidate } )}
				isClear={!disabled}
				onClear={onClearHandler}
				{...otherProps}
			/>
		);
	else return renderSelect();
};

export default CustomerSelect;
